'use client';

import { useEffect } from 'react';

/**
 * Conditionally loads cookie banner styles based on environment variable.
 * This is the Next.js equivalent of Gatsby's onInitialClientRender approach.
 */
export function CookieBannerStylesLoader() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_LINK_COOKIE_STYLES) {
      const link = document.createElement('link');
      link.href = '/cookie-banner-styles.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
  }, []);

  return null;
}
